import { type ReactNode } from 'react';
import { Modal, Button } from '@shared/ui';
import './DoubleCheckModal.css';

interface DoubleCheckModalProps {
    isOpen: boolean;
    onClose: () => void;
    title?: string;
    message?: ReactNode;
    firstButtonText?: string;
    firstButtonAction?: () => void;
    secondButtonText: string;
    secondButtonAction: () => void;
    isLoading?: boolean
}

export default function DoubleCheckModal({
    isOpen,
    onClose,
    title = 'Подтверждение',
    message,
    firstButtonText = "Отмена",
    firstButtonAction,
    secondButtonText,
    secondButtonAction,
    isLoading = false,
}: DoubleCheckModalProps) {
    const handleFirstButtonClick = () => {
        firstButtonAction?.();
        onClose();
    };

    const handleSecondButtonClick = () => {
        secondButtonAction();
    };

    return (
        <Modal
            size={400}
            isOpen={isOpen}
            onClose={onClose}
            title={title}
        >
            <div className="double-check-modal-content">
                {message && <div className="double-check-modal-message">{message}</div>}
                <div className="double-check-modal-actions">
                    <Button
                        onClick={handleFirstButtonClick}
                        variant="secondary"
                    >
                        {firstButtonText}
                    </Button>
                    <Button
                        onClick={handleSecondButtonClick}
                        variant="primary"
                        loading={isLoading}
                        disabled={isLoading}
                    >
                        {secondButtonText}
                    </Button>
                </div>
            </div>
        </Modal>
    );
}

